import { render, staticRenderFns } from "./AccountActivityBranch.vue?vue&type=template&id=bfb4160a&"
import script from "./AccountActivityBranch.vue?vue&type=script&lang=js&"
export * from "./AccountActivityBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports